import React, { useEffect } from 'react'
import Header from '../Components/Header/Header'

import HomeAll from '../Components/HomeAll/HomeAll'
function Home() {

  
  return (
    <div>
        <Header/>
        <HomeAll/>
    </div>
  )
}

export default Home